import styled from "styled-components/macro";

import icon_close from "../../../src/assets/icons/icon_close.svg"
import icon_search from "../../../src/assets/icons/icon_search.svg"
import { MobileButtonWrapper } from "../../styles/sharedStyles";

export const SearchContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background: #55749F;
  width: 100vw;
  height: 100vh;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: auto;

  &::-webkit-scrollbar {
    width: 0 !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
`;

export const MenuHeader = styled.div`
  width: 100%;
  max-width: 1320px;
  min-height: 64px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 24px;
  margin-bottom: 100px;

  @media (max-width: 979px) {
    max-width: none;
    min-height: 58px;
    margin-bottom: 40px;
  }
`

export const InnerSearchContainer = styled.div`
  width: 100%;
  max-width: 800px;

  @media (max-width: 979px) {
    max-width: none;
    padding: 0 43px;
  }
`;

export const SearchBar = styled.input`
  width: 100%;
  margin-right: 10px;
  padding: 6px 0;
  font-family: inherit;
  font-size: 22px;
  color: #fff;
  background: transparent;
  outline: none;
  border: none;
  border-bottom: 1px solid #fff;
  border-radius: 0;

  &::placeholder {
      color: #fff;
      opacity: 0.5;
  }
`;

export const SearchBarContainer = styled.div`
  display: flex;
  align-items: flex-end;
  height: 43px;
  margin-bottom: 40px;
`;

export const SearchText = styled.span`
  margin-bottom: 10px;
  font-size: 16px;
  line-height: 140%;
  color: #EEEFF0;
`;

export const IconSearch = styled.div`
  min-width: 48px;
  height: 48px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  background-image: url(${icon_search});
`;

export const ButtonWrapper = styled.div`
  padding: 15px;
`

export const CustomButtonWrapper = styled(MobileButtonWrapper)`
  margin-left: auto;
  padding-right: 17px;
`

export const Close = styled.span`
  width: 18px;
  height: 18px;
  display: block;
  cursor: pointer;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  background-image: url(${icon_close});
`;

export const AllResults = styled.ul`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
`;

export const ListItem = styled.li`
  height: 42px;
  padding: 10px 0;
  display: flex;
  align-items: center;
`

export const ResultLink = styled.a`
  font-size: 16px;
  color: rgba(255, 255, 255, 1);
  text-transform: capitalize;
  text-decoration: none;
  font-weight: 500;

  &:hover {
    color: #fff;
  }
`
